<template>
  <div class="reviews">
    <template v-if="tableItems.length">
      <AppTable
        :fields="tableFields"
        :items="tableItems"
        @sort="onSortTable"
      >
        <template #createdBy="data">
          <BaseLink :href="`/user/${data.createdBy.id}`">
            {{ data.createdBy.name }} {{ data.createdBy.surname }}
          </BaseLink>
        </template>

        <template #rating="data">
          <BaseStars :value="data.rating" />
        </template>

        <template #delete="{ id }">
          <div
            class="bin"
            @click="onDelete(id)"
          >
            <BaseIcon
              icon="bin"
              class="bin__icon"
            />
          </div>
        </template>
      </AppTable>

      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="reviews__pagination-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>
    <p v-else class="h3">Список отзывов пуст.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseStars from '@/components/Base/BaseStars'
import BaseIcon from '@/components/Base/BaseIcon'
import BaseLink from '@/components/Base/BaseLink'
import AppPagination from '@/components/Base/AppPagination'

export default {
  name: 'AppReviews',
  components: {
    AppPagination,
    BaseLink,
    BaseIcon,
    BaseStars,
    AppTable
  },
  data () {
    return {
      tableFields: [
        {
          key: 'createdBy',
          label: 'Автор',
          sortable: true,
          slot: true
        },
        {
          key: 'rating',
          label: 'Рейтинг',
          sortable: true,
          slot: true
        },
        {
          key: 'text',
          label: 'Содержание'
        },
        {
          key: 'delete',
          label: '',
          slot: true
        }
      ],
      tableItems: [],
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'id'
    }
  },
  computed: {
    requestBody () {
      return {
        id: this.$route.params.id,
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /** Отслеживанию изменение св-ва и подтягиваю новые данные таблицы */
    paginationCurrent: 'fetchReviews'
  },
  async created () {
    await this.fetchReviews()
  },
  methods: {
    async fetchReviews () {
      try {
        const { data } = await this.$api.field.comments(this.requestBody)
        const list = data?.list ?? []

        /* Записал общее колво */
        this.paginationTotal = data.pages * this.paginationPerPage

        this.tableItems = list.map(item => {
          const id = item?.id ?? null
          const createdBy = item?.createdBy ?? {}
          const rating = item?.rating ?? null
          const text = item?.text ?? null

          return {
            id,
            createdBy,
            rating,
            text
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchReviews()
    },
    async onDelete (id) {
      if (!confirm('Вы уверены?')) { return }

      const body = {
        fieldId: this.$route.params.id,
        commentId: id
      }

      try {
        await this.$api.field.deleteComment(body)
        await this.fetchReviews()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reviews {
  &__pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }

  .bin {
    width: 24px;
    height: 24px;
    color: red;
    cursor: pointer;

    &:hover {
      color: #ff5656;
    }
  }
}
</style>
